module.exports = __webpack_public_path__ + "img/入会后预览图@2x.68033785.png";